import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M14 6l-4.22 5.63 1.25 1.67L14 9.33 19 16h-8.46l-4.01-5.37L1 18h22L14 6zM5 16l1.52-2.03L8.04 16H5z"
}), 'FilterHdrOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FilterHdrOutlined.js
// module id = 3646
// module chunks = 2